function windowResize() {
    jQuery(function ($) {
        $(".caret2").removeClass("fa fa-chevron-down");
        $(".caret2").removeClass("rotate");
        var width = $(window).width();
        if (width <= 991) {
            $(".caret2").addClass("fa fa-chevron-down");
            $(".caret2").addClass("rotate");
        }
    });
}
jQuery(function ($) {
    $(function () {
        $(".dropdown").on("show.bs.dropdown hide.bs.dropdown", function () {
            $(this).find(".caret2").toggleClass("up");
        });
    });
    $.fn.almDone = function () {
        $('#load-more').hide();
    };
    $(document).ready(function () {
        $('.navbar-toggle').click(function() {
            $(this).toggleClass('toggled');
        });
        $('.nav-next > a, .nav-previous > a, .login-btn > a').click(function(e) {
            e.preventDefault();
            setTimeout(function() {
                window.location = $(e.target).attr('href');
            }, 500);
        });
        $(window).resize(function() {
            windowResize();
        })
        $(".caret2").removeClass("fa fa-chevron-down");
        $(".caret2").removeClass("rotate");
        var width = $(window).width();
        if (width <= 991) {
            $(".caret2").addClass("fa fa-chevron-down");
            $(".caret2").addClass("rotate");
        }
        $(".carousel").swipe({
            swipe: function (event, direction, distance, duration, fingerCount, fingerData) {
                if (direction == 'left') $(this).carousel('prev');
                if (direction == 'right') $(this).carousel('next');
            },
            allowPageScroll: "vertical"
        });
        $("#contact-form").validate({
            rules: {
                FullName: "required",
                Email: "required",
                Subject: "required",
                Message: "required"
            },
            messages: {
                FullName: "Please enter Full Name",
                Email: "Please enter Email",
                Subject: "Please enter Subject",
                Message: "Please enter Message."
            }
        });
        $("#sub-form").validate({
            rules: {
                FirstName: "required",
                LastName: "required",
                Email: {
                    required: true,
                    email: true
                }
            },
            messages: {
                FirstName: "Please enter First Name",
                LastName: "Please enter Last Name",
                Email: {
                    required: "Please enter Email",
                    email: "Please enter the valid Email"
                }
            }
        });
    });
});


// WEBPACK FOOTER //
// ./scripts/old/misc.js